import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import './PdfViewer.css';

const PdfViewer = ({ url, onClose }) => {
    if (!url) return null;

    return (
        <Box className="pdf-viewer-overlay">
            <Box className="pdf-viewer-header">
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    className="pdf-viewer-close-btn"
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" className="pdf-viewer-title">
                    Policy Document
                </Typography>
            </Box>

            <iframe
                src={url}
                className="pdf-viewer-iframe"
                title="Policy Document"
            />
        </Box>
    );
};

export default PdfViewer;
